export default function Products() {
  return [
    {
      displayOrder: 1,
      productName: "Fully Underwritten Term",
      productLink: "/quote/term-life-insurance/personalizing-options",
      productIconPath: "calendar",
      openInNewTab: false,
      productTypeId: 1,
      displayName: "Term Life Insurance",
      productLandingUrl: "/landing/term",
      submittingAgentCode: null,
      hideAllProductsDefault: true,
      vssEnabled: false,
      enablePredictivePathPreQuote: false
    },
    {
      displayName: "Permanent Life Insurance",
      productIconPath: "moneybag",
      productLink: "/quote/whole-life/securian-secure-promise",
      productLandingUrl: "/landing/permanent"
    },
    {
      displayName: "Loan Protector",
      productIconPath: "shield-checkmark",
      productLink: "/quote/term-life-insurance/loan-protector",
      productLandingUrl: "/landing/loan-protector"
    },
    {
      displayName: "Children's Life Insurance",
      productIconPath: "juvenile",
      productLink: "/quote/whole-life/securian-secure-promise?juvi",
      productLandingUrl: "/landing/children"
    },
    {
      displayName: "Disability Income",
      productIconPath: "crutch",
      productLink: "/landing/disability-income",
      productLandingUrl: "/landing/disability-income"
    },
    {
      displayName: "Supplemental Insurance",
      productIconPath: "stethoscope",
      productLink: "/landing/supplemental",
      productLandingUrl: "/landing/supplemental"
    },
    {
      displayName: "Navigating Medicare",
      productIconPath: "elderly",
      productLink: "/landing/navigating-medicare",
      productLandingUrl: "/landing/navigating-medicare"
    },
    {
      displayName: "Long Term Care",
      productIconPath: "elderly",
      productLink: "/quote/long-term-care",
      productLandingUrl: "/landing/long-term-care"
    }
  ]
};


// WEBPACK FOOTER //
// ./src/components/Helpers/Data/Products/Products.js